// @flow

import modals from 'modals';

import { profile } from 'myrgs-auth-helpers';

import FormController from './controller';

import template from '../templates/modal.html';


module.exports = class CalculatorFeedbackModalController extends FormController {
	constructor (options: *) {
		super(options);

		this._modal = modals.create({
			css: { 'modal-lg': true },
			templateMode: 'content',
			template: this._modalTemplate(),
		});
	}

	_modalTemplate () {
		return {
			html: template(),
			data: this,
		};
	}

	async show () {
		await profile.updateAtLeastOnce();

		this.loadPrefilling(profile.toJS());

		modals.show(this._modal);
	}

	hide () {
		modals.hide(this._modal);
	}
};
